import { FC, useEffect, useState } from 'react';
import { FormContainer, useForm } from 'react-hook-form-mui';

import { useFilters } from '../analytics/useAnalytics';
import { PerformanceTopContent } from './TopContent';
import { PerformanceTabs } from './Tabs';
import { PerformanceContentSavings } from './ContentSavings';
import { PerformanceContentVolumetric } from './ContentVolumetric';
import { TableTab } from '../analytics/table/useTable';
import { IPerformanceMainProps } from './types';

export const PerformanceAnalysisMain: FC<IPerformanceMainProps> = ({ hashedFilter, setHashedFilter }) => {
  const [tabName, setTabName] = useState<string>(TableTab.SAVINGS);

  const { data: filtersMetadata } = useFilters('PERFORMANCE_ASSESSMENT', hashedFilter.filters.formValues);
  const dataFilter = filtersMetadata?.filters;

  const formContext = useForm({
    defaultValues: {
      ...hashedFilter.filters.formValues,
      name: hashedFilter.name,
      description: hashedFilter.description,
    },
  });

  // Listen for changes to name and description fields and update hashedFilter
  const name = formContext.watch('name');
  const description = formContext.watch('description');

  useEffect(() => {
    if (name !== hashedFilter.name || description !== hashedFilter.description) {
      setHashedFilter({
        ...hashedFilter,
        name: name || hashedFilter.name,
        description: description || hashedFilter.description,
      });
    }
  }, [name, description, hashedFilter, setHashedFilter]);

  return (
    <FormContainer formContext={formContext}>
      <div className='sticky top-0 z-10 bg-white border-b border-grey-30'>
        <PerformanceTopContent dataFilter={dataFilter} hashedFilter={hashedFilter} allowedCurrencies={filtersMetadata?.allowedCurrencies} />
        <PerformanceTabs selected={tabName} onChangeTab={(name) => setTabName(name)} />
      </div>
      <div className='py-24'>
        {tabName === TableTab.SAVINGS ? <PerformanceContentSavings dataFilter={dataFilter} /> : <PerformanceContentVolumetric dataFilter={dataFilter} />}
      </div>
    </FormContainer>
  );
};
